import { render, staticRenderFns } from "./StepBoxes.vue?vue&type=template&id=0a4fe908&scoped=true&"
import script from "./StepBoxes.vue?vue&type=script&lang=js&"
export * from "./StepBoxes.vue?vue&type=script&lang=js&"
import style0 from "./StepBoxes.vue?vue&type=style&index=0&id=0a4fe908&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4fe908",
  null
  
)

export default component.exports